import React, { useEffect, useState } from 'react';
import Table from '../../components/tables/Table';
import CustomLoading from '../../components/customLoading/CustomLoading';
import { toast } from 'react-toastify';
import { BiRefresh } from 'react-icons/bi';
import SearchBar from '../../components/searchBar/SearchBar';
import { getUsers } from '../../services/fpo';

function FpoUsers() {
    const [searchText, setSearchText] = useState("");

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const headers = [
        { label: "Time", key: "updated_at" },
        { label: "Name", key: "name" },
        { label: "FPO", key: "fpo_name" },
        { label: "Phone", key: "mobile_number" },
    ];

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getUsers(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data)
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`?search=${query}`);
    };

    const resetFilters = () => {
        setSearchText("");
        fetchData("");
    };

    return (<>
        <div className="flex flex-row gap-2 items-center">
            <SearchBar
                placeholder="Start typing here..."
                onSearch={handleSearch}
                value={searchText}
            />

            {/* Reset Filters Icon */}
            {(searchText.length !== 0) && (
                <BiRefresh
                    size={24}
                    className="cursor-pointer text-primary"
                    onClick={resetFilters}
                />
            )}
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                name: <p>{item.name}</p>,
                                updated_at: <p>{item.updated_at}</p>,
                                fpo_name: <p>{item.fpo_name}</p>,
                                fpo_name: <p>{item.fpo_name}</p>,
                                mobile_number: <p>{item.mobile_number}</p>,
                            }))}
                    />
                </div>}
    </>);
}

export default FpoUsers;